import React from 'react';

import { t } from '@lingui/macro';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { Button, ParagraphMd } from '@olist/design-system';

import { PageLayout } from 'components';
import { ButtonWrapper, Logos, Title } from 'components/general';
import { OlistExpiredLink } from 'components/icons/appLogos';
import useMixPanel from 'hooks/use-mixpanel';

export default function ResetPasswordInvalid() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { track } = useMixPanel(false);

  const type = searchParams.get('type') || '';
  const token = searchParams.get('token') || '';

  let message =
    'Este link de redefinição de senha expirou ou já foi usado. Solicite uma nova troca de senha para continuar.';
  let redirect = '/auth/request-recovery';

  if (type === 'invalid_pass') {
    message = 'A nova senha inserida é igual à antiga. Insira uma senha diferente.';
    redirect = `/auth/reset-password?token=${token}&token_type=olist_accounts_reset_password`;
  }

  return (
    <PageLayout>
      <section>
        <Logos>
          <OlistExpiredLink />
        </Logos>
        <Title>{t`expired password change`}</Title>
        <ParagraphMd>{message}</ParagraphMd>
        <ButtonWrapper>
          <Button
            fixed
            variation="secondary"
            size="medium"
            onClick={() => {
              track('Reset Password Invalid - Clicked on Request New Password');
              navigate(redirect);
            }}
            className="button"
          >
            {t`request new password`}
          </Button>
        </ButtonWrapper>
      </section>
    </PageLayout>
  );
}
